import React, { DragEvent, FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { externalContentRootState } from '../../../pages/externalContent';
import { useTranslate } from '@tolgee/react';
import { Accordion, Button, Form, OverlayTrigger, Popover } from 'react-bootstrap';

import { MAIN_COLOR_CODES, PRIMARY_DARK } from '../../../config/constants';
import MediaUploadBox from './mediaUploadArea/MediaBox';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import {
  addDraggedFiles,
  setPostPublicationDate
} from '../../../redux/slices/externalContent/externalContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowUp } from '@fortawesome/pro-duotone-svg-icons';
import { getLocationDetails } from '../../../redux/slices/location/locationDetails';
import QuillEditor from './textEditor';
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
  GoogleReCaptcha
} from 'react-google-recaptcha-v3';
import { postExternalCollectedData } from '../../../redux/slices/externalContent/utils';
import { ADDITIONALINFO, COLLECTINFOVIEW, MAINTEXT, SUCCESSVIEW } from '../utils/constant';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import * as dateRangeLocales from 'react-date-range/dist/locale';
import { Calendar } from 'react-date-range';
import moment from 'moment-timezone';
import { getLanguage } from '../../../locales/i18n';
import { getDateTimeFormated } from '../../utils/dates/utils';
import CollectHero from './collectHero';

interface Props {
  setCurrentView: React.Dispatch<React.SetStateAction<string>>;
  currentView: string;
  sortableListRef: any;
}
const SuggestAPost: FC<Props> = ({
  setCurrentView,
  currentView,
  sortableListRef
}) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const userInfo = useSelector(
    (state: externalContentRootState) => state.externalContent
  );
  const asset_uploading_status = useSelector(
    (state: externalContentRootState) => state.externalContent.assetUploading
  );

  const [uploading, setUploading] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [dateDropdown, setDateDropdown] = useState(false);

  const { locationslug } = useParams();
  useEffect(() => {
    if (locationslug) dispatch(getLocationDetails(locationslug) as any);
  }, []);
  const [dragIsOver, setDragIsOver] = useState(false);

  const postData = useSelector(
    (state: externalContentRootState) => state.externalContent.postData
  );
  const externalContentConfig = useSelector(
    (state: externalContentRootState) => state.externalContent.externalContentConfig
  );
  const publicationDate = useSelector(
    (state: externalContentRootState) =>
      state.externalContent.postData.post_planned_publication_date
  );

  const handleUpload = (filteredFiles: any[]) => {
    dispatch(
      addDraggedFiles({
        files: filteredFiles
      })
    );
  };

  // ---- Publication date picker state (date only) ----
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const onDateChange = (item: Date) => {
    setSelectedDate(item);
    // Store as a plain YYYY-MM-DD string — no time component.
    dispatch(setPostPublicationDate(moment(item).format('YYYY-MM-DD')));
    setDatePickerOpen(false);
  };

  const clearPublicationDate = () => {
    setSelectedDate(null);
    dispatch(setPostPublicationDate(null));
  };

  const datePickerPopover = (
    <Popover
      id="external-publication-date-popover"
      style={{ maxWidth: '370px', width: '100%' }}
    >
      <Popover.Body style={{ width: '100%' }}>
        <Calendar
          onChange={(item) => onDateChange(item as Date)}
          minDate={new Date()}
          maxDate={new Date(new Date().getFullYear() + 1, 11, 31)}
          locale={
            (dateRangeLocales as any)[getLanguage()] ||
            (dateRangeLocales as any).enGB
          }
          date={selectedDate || new Date()}
          className="w-100"
        />
      </Popover.Body>
    </Popover>
  );

  const handleSubmit = async () => {
    if (!postData.post_text && postData.media?.length < 1) {
      toast.error(`${t('externalConternt.errors.emptyMediaText')}`, {
        duration: 4000,
        position: 'top-right'
      });
      return;
    }

    setUploading(true);
    let recaptchaToken;
    try {
      recaptchaToken = await executeRecaptcha('uploadExternalCollect');
      // Add your code logic here that uses recaptchaToken
      console.log('Recaptcha token:', recaptchaToken);
    } catch (error) {
      toast.error(`${t('externalConternt.errors.recaptchaFailed')}`, {
        duration: 4000,
        position: 'top-right'
      });

      console.error('Error during handleSubmit:', error);
    }
    if (recaptchaToken) {
      const data = {
        recaptcha: recaptchaToken,
        author_name: postData.authorInformation?.name,
        author_email: postData.authorInformation?.email,
        author_license_info: postData.authorInformation?.license_info,
        author_message: postData.authorInformation?.message,
        post_additional_information: postData?.post_additional_information,
        post_planned_publication_date: postData.post_planned_publication_date,
        post_text: postData?.post_text,
        media: postData?.media.map((item) => ({
          uuid: item.uuid
        }))
      };

      await postExternalCollectedData(
        {
          ...data,
          ...((externalContentConfig?.scope !== 'location' &&
            postData?.cloudUuid)
            ? { cloud: postData.cloudUuid }
            : {})
        },
        {},
        () => {
          setUploading(false);
          toast.error(`${t('externalContent.errors.submissionFailed')}`, {
            duration: 4000,
            position: 'top-right'
          });
          console.log('error here');
        },
        () => {
          setCurrentView(SUCCESSVIEW);
        },
        externalContentConfig?.submit_url
      );
    }
    setUploading(false);
  };

  console.log('suggest a post console', userInfo);
  return (
    <div
      className="w-100 d-flex flex-column gap-3 externalCreator mx-auto"
      style={{ maxWidth: 900 }}
    >
      <div className="py-4 px-4 px-md-5 bg-white w-100 rounded-3">
        <CollectHero step={2} stepLabelKey="externalContent.step.content" />
      </div>
      <div className="d-flex flex-column gap-3 py-4 px-5 bg-white w-100 rounded-3">
        <div className="d-flex flex-column w-100">
          <h3> {t('externalContent.postCreator.media')}</h3>
          <div className="text-muted">
            {' '}
            {t('externalContent.helpText.media')}
          </div>
        </div>

        <div>
          <MediaUploadBox sortableListRef={sortableListRef} />
        </div>
      </div>

      <div className="d-flex flex-column gap-3 py-4 px-5 bg-white w-100 rounded-3">
        <div className="d-flex flex-column w-100">
          <h3> {t('externalContent.postCreator.text')}</h3>
          <div className="text-muted">
            {' '}
            {t('externalContent.helpText.text')}
          </div>
        </div>

        <div>
          <QuillEditor TextField={MAINTEXT} />
        </div>
      </div>

      <div className="d-flex flex-column gap-3 p-4 bg-white w-100 rounded-3">
        <Accordion flush alwaysOpen>
          <Accordion.Item className="p-0 m-0 bg-transparent" eventKey="0">
            <Accordion.Header className="border-0 p-0 m-0 bg-transparent">
              {' '}
              <h3> {t('externalContent.publication_date')}</h3>
            </Accordion.Header>
            <Accordion.Body style={{ padding: '0 6px' }} className="">
              <Form.Group className="mb-2 w-100">
                <OverlayTrigger
                  trigger="click"
                  placement="auto"
                  show={datePickerOpen}
                  onToggle={(next) => setDatePickerOpen(next)}
                  rootClose
                  overlay={datePickerPopover}
                >
                  <div className="input-group">
                    <Form.Control
                      id="external-publication-date"
                      type="text"
                      readOnly
                      style={{ cursor: 'pointer', backgroundColor: 'white' }}
                      placeholder={t('date')}
                      autoComplete="off"
                      value={
                        selectedDate ? getDateTimeFormated(selectedDate, true) : ''
                      }
                      onClick={() => setDatePickerOpen((prev) => !prev)}
                    />
                    <Button
                      variant="secondary"
                      className="rounded-end"
                      onClick={() => setDatePickerOpen((prev) => !prev)}
                    >
                      <i className="fa-duotone fa-calendar-days"></i>
                    </Button>
                  </div>
                </OverlayTrigger>
              </Form.Group>
              {selectedDate && (
                <div className="d-flex justify-content-end mb-2">
                  <button
                    type="button"
                    className="btn btn-link btn-sm text-muted p-0"
                    onClick={clearPublicationDate}
                  >
                    {t('lomavisCreator.planningSlide.clear_date')}
                  </button>
                </div>
              )}
              <div className="text-muted">
                {' '}
                {t('externalContent.helpText.publicationDate')}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>

      <div className="d-flex flex-column gap-3 p-4 bg-white w-100 rounded-3">
        <Accordion flush alwaysOpen>
          <Accordion.Item className="p-0 m-0 bg-transparent" eventKey="0">
            <Accordion.Header className="border-0 p-0 m-0 bg-transparent">
              {' '}
              <h3> {t('externalContent.postCreator.addInfo')}</h3>
            </Accordion.Header>
            <Accordion.Body style={{ padding: '0 6px' }} className="">
              <div className="text-muted mb-2">
                {' '}
                {t('externalContent.helpText.addInfo')}
              </div>
              <div className="w-100 d-flex flex-column gap-2">
                <QuillEditor TextField={ADDITIONALINFO} />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>

      <div className="d-flex flex-column flex-sm-row gap-2 w-100">
        <Button
          variant="light"
          size="lg"
          onClick={() => setCurrentView(COLLECTINFOVIEW)}
          className="order-2 order-sm-1"
          style={{ minWidth: 120 }}
          disabled={uploading || asset_uploading_status}
        >
          <i className="fa-regular fa-arrow-left me-2"></i>
          {t('externalContent.back')}
        </Button>
        <Button
          variant="primary"
          size="lg"
          onClick={() => {
            handleSubmit();
          }}
          className="flex-grow-1 order-1 order-sm-2"
          disabled={uploading || asset_uploading_status}
        >
          {uploading && (
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
          )}
          {uploading
            ? t('externalContent.saving')
            : t('externalContent.postCreator.submit')}
        </Button>
      </div>
    </div>
  );
};

export default SuggestAPost;
